import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';

function useIntersectionObserver(_ref) {
  var target = _ref.target,
    options = _ref.options,
    onIntersect = _ref.onIntersect,
    onEscape = _ref.onEscape;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isIntersecting = _useState2[0],
    setIntersecting = _useState2[1];
  useEffect(function () {
    if (!target) {
      return;
    }
    var observer = new IntersectionObserver(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        isIntersecting = _ref3[0].isIntersecting;
      setIntersecting(isIntersecting);
      isIntersecting ? onIntersect === null || onIntersect === void 0 ? void 0 : onIntersect() : onEscape === null || onEscape === void 0 ? void 0 : onEscape();
    });
    observer.observe(target);
    return function () {
      return observer.disconnect();
    };
  }, [target, options, onIntersect, onEscape]);
  return isIntersecting;
}

export { useIntersectionObserver };
//# sourceMappingURL=useIntersectionObserver.js.map
